import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// UTILS
import { treatObjNullValues } from 'utils/genericFunctions';

// ACTIONS
import { pesquisaCITAAACSuccess, pesquisaCITAAACFailure } from './actions';

// TYPES
import { DataPesquisaCITA, Types } from './types';

function* pesquisaCITAAACRequest(request: ReducerActionRotaSP) {
	const { token, payload } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`cirg/${payload.numeroRg}`,
		undefined,
		undefined,
		undefined,
		undefined,
		{ usuario: payload.usuario, senha: payload.senha },
		undefined,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(
			pesquisaCITAAACSuccess(
				treatObjNullValues(response.data) as DataPesquisaCITA,
			),
		);
	} else if (response.error) {
		yield put(pesquisaCITAAACFailure());
	}
}

export default all([
	takeLatest(Types.PESQUISA_CITA_AAC_REQUEST, pesquisaCITAAACRequest),
]);
